export const safeReturnUrl = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return undefined
  try {
    const url = new URL(value, window.location.origin)
    if (url.origin !== window.location.origin || /^\/(login|interstitial\.html)(\/|$)/.test(decodeURIComponent(url.pathname).toLowerCase())) return undefined
    return `${url.pathname}${url.search}${url.hash}`
  } catch (_) {
    return undefined
  }
}

export const currentPageUrl = (location) => `${location.pathname}${location.search || ''}${location.hash || ''}`

export const getLoginReturnUrl = (location) => (
  safeReturnUrl(new URLSearchParams(location.search).get('return')) || safeReturnUrl(location.state?.redirectUrl)
)

export const loginUrl = (returnUrl, expired = false) => {
  const params = new URLSearchParams()
  const target = safeReturnUrl(returnUrl)
  if (target) params.set('return', target)
  if (expired) params.set('reason', 'expired')
  return `/login${params.toString() ? `?${params}` : ''}`
}

export const oauthLoginUrl = (baseUrl, returnUrl) => {
  const url = new URL(baseUrl)
  const callback = new URL(url.searchParams.get('redirect_uri'))
  // The backend overwrites `return` for business users; keep our validated destination separate.
  callback.searchParams.set('login_return', loginUrl(returnUrl))
  url.searchParams.set('redirect_uri', callback.toString())
  return url.toString()
}
